<ng-container *ngIf="showBloque">
  <div class="bloque-comentarios">
    <ng-container *ngIf="showTitulo">
      <div class="titulo-comentarios">
        <h4>{{ numComentarios }} {{ numComentarios == 1 ? "comentario" : "Comentarios" }}</h4>
        <div class="compartir-rss">
          <div class="sidebar-icon" (click)="mostrarRRSS()">
            <app-icon-share [selected]="rrssVisible" [shared]="true"></app-icon-share>
          </div>
          <div class="rrss" [style.display]="rrssVisible ? 'flex' : 'none'">
            <a href="https://www.facebook.com/sharer/sharer.php?u={{ noticia?.urlNoticia }}" target="_blank">
              <img src="assets/images/facebook.webp" alt="facebook" class="icons" />
            </a>
            <a href="https://twitter.com/intent/tweet?text={{ noticia?.tituloVideo }} - {{ noticia?.urlNoticia }}" data-size="large" target="_blank">
              <img src="assets/images/x.webp" alt="x" class="icons" />
            </a>
            <a href="https://api.whatsapp.com/send?text={{ noticia?.tituloVideo }} - {{ noticia?.urlNoticia }}" data-action="share/whatsapp/share" target="_blank">
              <img src="assets/images/whatsapp.webp" alt="whatsapp" class="icons" />
            </a>
            <a href="https://www.linkedin.com/sharing/share-offsite/?url={{ noticia?.urlNoticia }}" target="_blank">
              <img src="assets/images/linkedin.webp" alt="linkedin" class="icons" />
            </a>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="showTextarea">
      <app-send-comment-textarea [idVideo]="idVideo" (onSendComment)="onSendComment($event)"></app-send-comment-textarea>
      <ng-container *ngIf="showLogin && !userId">
        <div class="login"><span (click)="openLoginDialog()" (keypress)="openLoginDialog()">Inicia sesión</span> o <span (click)="openRegistroDialog()" (keypress)="openRegistroDialog()">registrate</span> para comentar</div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="showComentarios">
      <div class="contenedor-comentarios">
        <ng-container *ngFor="let comentario of comentariosPaginados; trackBy: comentario">
          <app-comment [idVideo]="idVideo" [comment]="comentario" [showFecha]="showFecha" [showNombre]="showNombre"></app-comment>
        </ng-container>
        <ng-container *ngIf="comentarios?.length > 4">
          <mat-paginator [length]="comentarios?.length" [pageSize]="numeroComentariosPagina" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="showFirstLastButtons" (page)="cambiarPagina($event)"> </mat-paginator>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
